import { useMemo } from 'react';

import { Image, ImageParams } from '~/src/common/typings/image';
import { getImageUrlFromFormat } from '~/src/common/utils/cloudinary';

import { ImageSliderEntry } from './types';

export const useImageSliderData = (images: Image[]): ImageSliderEntry[] => {
  return useMemo(() => {
    return images.map(image => ({
      id: image.id,
      alt: image.alt,
      src: {
        s: getImageUrlFromFormat(image, 'square', ImageParams.productThumbnail),
        m: getImageUrlFromFormat(image, 'square', ImageParams.productPage),
        l: getImageUrlFromFormat(image, undefined, ImageParams.zoomedIn),
      },
    }));
  }, [images]);
};
